import { handleActions } from 'modules/helpers';
import { ActionTypes } from 'constants/index';

export const appState = {
  list: [],
  pages: 0,
  currentPage: 1,
  listLoading: false,
  rowsLoading: false,
  uploading: false,
  savingRow: false,
  approving: false,
  deleting: false,
  currentImport: null,
  rows: [],
  rowPages: 0,
  rowCurrentPage: 1,
  lastApproveResult: null,
};

export default {
  locationImports: handleActions(
    {
      [ActionTypes.GET_LOCATION_IMPORTS]: draft => {
        draft.listLoading = true;
      },
      [ActionTypes.GET_LOCATION_IMPORTS_SUCCESS]: (
        draft,
        { payload: { rows, pages, currentPage } },
      ) => {
        draft.list = rows || [];
        draft.pages = pages || 0;
        draft.currentPage = currentPage || 1;
        draft.listLoading = false;
      },
      [ActionTypes.GET_LOCATION_IMPORTS_FAILURE]: draft => {
        draft.listLoading = false;
      },

      [ActionTypes.GET_LOCATION_IMPORT]: draft => {
        draft.rowsLoading = true;
        // Clear stale approve result when switching imports
        draft.lastApproveResult = null;
      },
      [ActionTypes.GET_LOCATION_IMPORT_SUCCESS]: (
        draft,
        { payload: { import: currentImport, rows, pages, currentPage } },
      ) => {
        draft.currentImport = currentImport || null;
        draft.rows = rows || [];
        draft.rowPages = pages || 0;
        draft.rowCurrentPage = currentPage || 1;
        draft.rowsLoading = false;
      },
      [ActionTypes.GET_LOCATION_IMPORT_FAILURE]: draft => {
        draft.rowsLoading = false;
      },

      [ActionTypes.UPLOAD_LOCATION_IMPORT]: draft => {
        draft.uploading = true;
      },
      [ActionTypes.UPLOAD_LOCATION_IMPORT_SUCCESS]: (draft, { payload }) => {
        draft.uploading = false;
        draft.currentImport = payload.import || null;
        draft.rows = payload.rows || [];
        // Clear stale approve result on new upload
        draft.lastApproveResult = null;
      },
      [ActionTypes.UPLOAD_LOCATION_IMPORT_FAILURE]: draft => {
        draft.uploading = false;
      },

      [ActionTypes.UPDATE_LOCATION_IMPORT_ROW]: draft => {
        draft.savingRow = true;
      },
      [ActionTypes.UPDATE_LOCATION_IMPORT_ROW_SUCCESS]: (draft, { payload }) => {
        draft.savingRow = false;
        draft.rows = draft.rows.map(row => (row.id === payload.id ? payload : row));
      },
      [ActionTypes.UPDATE_LOCATION_IMPORT_ROW_FAILURE]: draft => {
        draft.savingRow = false;
      },

      [ActionTypes.APPROVE_LOCATION_IMPORT]: draft => {
        draft.approving = true;
      },
      [ActionTypes.APPROVE_LOCATION_IMPORT_SUCCESS]: (draft, { payload }) => {
        draft.approving = false;
        draft.lastApproveResult = payload.results || null;
        if (payload.import) {
          draft.currentImport = payload.import;
        }
      },
      [ActionTypes.APPROVE_LOCATION_IMPORT_FAILURE]: draft => {
        draft.approving = false;
      },

      [ActionTypes.CLEAR_LOCATION_IMPORT_APPROVE_RESULT]: draft => {
        draft.lastApproveResult = null;
      },

      [ActionTypes.DELETE_LOCATION_IMPORT]: draft => {
        draft.deleting = true;
      },
      [ActionTypes.DELETE_LOCATION_IMPORT_SUCCESS]: (draft, { payload }) => {
        draft.deleting = false;
        if (
          payload &&
          payload.deletedId != null &&
          draft.currentImport &&
          draft.currentImport.id === payload.deletedId
        ) {
          draft.currentImport = null;
          draft.rows = [];
        }
      },
      [ActionTypes.DELETE_LOCATION_IMPORT_FAILURE]: draft => {
        draft.deleting = false;
      },
    },
    appState,
  ),
};
